import styled from 'styled-components';

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
